import * as React from 'react';
import { QueryResult, OperationVariables } from 'react-apollo';

import ACCOUNT_NAVIGATION_QUERY from 'user/queries/AccountNavigationQuery.gql';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import Icon from 'components/Icon';
import Greeting from 'components/GreetingDeprecated';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';
// @ts-ignore
import TriggerComposerButton from 'chat/components/TriggerComposerButton';
import UserAvatar from 'users/components/UserAvatar';
import UserNavigationMenu from 'components/UserNavigationMenu';
import { HoCQueryComponent } from 'types/typescript/util';

import { AccountNavigationQuery as AccountNavigationQueryData } from 'user/queries/__generated__/AccountNavigationQuery';

import './styles/AccountNavigationDeprecated.scss';

type Props = {
  apolloProps: QueryResult<AccountNavigationQueryData>;
};

function AccountNavigationDeprecated(props: Props) {
  const user = props.apolloProps.data?.user;
  const canAddProfilePicture = CurrentUser.getUser().canAddProfilePicture();
  const name = user ? user.display_name : '_ _ _';
  const isAdminOfPaidOrg = !!user?.organizations?.length;

  return (
    <div className="AccountNavigationDeprecated">
      {canAddProfilePicture && user && (
        <Link to="/settings/profile">
          <UserAvatar
            className="AccountNavigationDeprecated-avatar"
            user={user}
            color="white"
            size="large"
          />
        </Link>
      )}
      <div className="AccountNavigationDeprecated-content">
        <Text color="thunder" size="xsmall">
          <Greeting />,
        </Text>
        <UserNavigationMenu isAdminOfPaidOrg={isAdminOfPaidOrg}>
          <Link color="inherit" className="AccountNavigationDeprecated-content-user">
            <Text truncate size="large">
              {name}
            </Text>
            <Glyph name="chevron-down" size="xsmall" />
          </Link>
        </UserNavigationMenu>
      </div>
      <TriggerComposerButton
        full
        label={
          <>
            <MediaObject center figure="right">
              <TextWithIcon center iconSize="medium" icon="pencil-compose-stroke">
                New message
              </TextWithIcon>
              <Icon name="chevron-down" size="small" />
            </MediaObject>
          </>
        }
      />
    </div>
  );
}

const QueryComponent = HoCQueryComponent<AccountNavigationQueryData, OperationVariables, {}>(
  // function 1
  { query: ACCOUNT_NAVIGATION_QUERY }
);
const WrappedComponent = QueryComponent(AccountNavigationDeprecated);
export { AccountNavigationDeprecated };
export default WrappedComponent;
